import { useMsal, } from '@azure/msal-react';
import { useState } from 'react';
import { FileApi } from '../../api/file/file-api';
import _ from 'lodash';
import { FileFunctions } from '../../api/file/file-functions';
import { UploadFileModal } from './file-upload-modal';
import { arrayAny } from '../../utils/arrayUtils';

export const FileVersionToolBar = ({ deleteSelectedVersions, enableDelete, unSelectAll, selectAll, makeCurrent, makeCurrentEnabled }) => {

    return (
        <div className="mb-0 d-flex text-nowrap p-3">

            <div className="btn-group me-2">
                <button onClick={selectAll} type="button" className="btn btn-sm btn-white"><i className="fa fa-fw fa-check ms-n1"></i> Select All</button>
                <button onClick={unSelectAll} type="button" className="btn btn-sm btn-white"><i className="far fa-fw fa-square ms-n1"></i> Unselect All</button>
            </div>
            <div className="btn-group me-2">
                {enableDelete && <button onClick={deleteSelectedVersions} title="Delete Selected Items" type="button" className="btn btn-sm btn-white me-2 px-2"><i className="fa fa-fw fa-trash"></i> Delete Selected</button>}
                {makeCurrentEnabled && <button onClick={makeCurrent} title="Rollback to this version" type="button" className="btn btn-sm btn-white me-2 px-2"><i className="fa fa-fw fa-bolt"></i> Make Current</button>}
            </div>
        </div>
    );

};

export const FileManagerToolbar = () => {

    return (
        <div className="file-manager-toolbar">
            <button type="button" className="btn shadow-none text-body border-0"><i className="fa fa-lg me-1 fa-plus"></i> File</button>
            <button type="button" className="btn shadow-none text-body border-0"><i className="fa fa-lg me-1 fa-plus"></i> Folder</button>
            <button type="button" className="btn shadow-none text-body text-opacity-50 border-0" disabled><i className="fa fa-lg me-1 fa-copy"></i> Copy</button>
            <button type="button" className="btn shadow-none text-body text-opacity-50 border-0" disabled><i className="fa fa-lg me-1 fa-move"></i> Move</button>
            <button type="button" className="btn shadow-none text-body border-0"><i className="fa fa-lg me-1 fa-upload"></i> Upload</button>
            <button type="button" className="btn shadow-none text-body text-opacity-50 border-0" disabled><i className="fa fa-lg me-1 fa-download"></i> Download</button>
            <button type="button" className="btn shadow-none text-body text-opacity-50 border-0" disabled><i className="fa fa-lg me-1 fa-xmark"></i> Delete</button>
            <button type="button" className="btn shadow-none text-body text-opacity-50 border-0" disabled><i className="fa fa-lg me-1 fa-rotate-left"></i> Restore</button>
            <button type="button" className="btn shadow-none text-body text-opacity-50 border-0" disabled><i className="fa fa-lg me-1 fa-file"></i> Rename</button>
            <button type="button" className="btn shadow-none text-body text-opacity-50 border-0" disabled><i className="fa fa-lg me-1 fa-pen"></i> Edit</button>
            <button type="button" className="btn shadow-none text-body text-opacity-50 border-0" disabled><i className="fa fa-lg me-1 fa-pen-to-square"></i> HTML Editor</button>
            <button type="button" className="btn shadow-none text-body text-opacity-50 border-0" disabled><i className="fa fa-lg me-1 fa-key"></i> Permissions</button>
            <button type="button" className="btn shadow-none text-body text-opacity-50 border-0" disabled><i className="fa fa-lg me-1 fa-file"></i> View</button>
            <button type="button" className="btn shadow-none text-body text-opacity-50 border-0" disabled><i className="fa fa-lg me-1 fa-lock-open"></i> Extract</button>
            <button type="button" className="btn shadow-none text-body text-opacity-50 border-0" disabled><i className="fa fa-lg me-1 fa-file-zipper"></i> Compress</button>
        </div>
    );

};

export const FileManagerSecondToolbar = ({
    isRoot, moveUp, goHome,
    refresh, refreshDisabled,
    handleShowMultiSelectToggle,
    multiSelect, handleShowDeletedToggle,
    showDeleted, itemsSelected,
    deleteSelectedItems, currentFolder,
    selectAll, unSelectAll
}) => {

    const { instance, inProgress, accounts } = useMsal();
    const fileApi = new FileApi(instance, inProgress, accounts);

    const [showUpload, setShowUpload] = useState(false);
    const [files, setFiles] = useState([]);
    const [optionalFilePath, setOptionalFilePath] = useState("");
    const [uploadProgress, setUploadProgress] = useState(null);
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [rerender, setRerender] = useState(false);

    currentFolder = FileFunctions.cleanBlobPath(typeof currentFolder === 'function' ? currentFolder() : currentFolder);

    const totalSize = () => _.sumBy(files, f => f.size);

    const uploadFiles = () => {

        if (uploadInProgress) {
            return;
        }

        setUploadInProgress(true);
        setUploadProgress(0);

        fileApi.uploadFiles(null, `${FileFunctions.cleanBlobPath(optionalFilePath)}${currentFolder}`, files, data => {
            const totalRemaining = _.sumBy(data, d => d.remainingBytes);
            const progress = 1 - (totalRemaining / totalSize());
            console.log(`Progress: ${progress * 100} %`);
            setUploadProgress(progress);
            setRerender(!rerender);
        })
            .then(files => {
                setRerender(!rerender);
                setUploadInProgress(false);
                setUploadProgress(0);
                handleSetShowUpload();
                refresh();
                console.log("Files were successfully uploaded", files);
            })
            .catch(error => { console.log("Error occurred persisting files.", error); });
    };

    const handleSetShowUpload = () => {
        setShowUpload(!showUpload)
        setFiles([]);
        setOptionalFilePath("");
    };

    return (
        <div className="mb-0 d-flex text-nowrap p-3 border-bottom">

            <UploadFileModal
                handleCancel={handleSetShowUpload}
                handleSave={uploadFiles}
                setFiles={setFiles}
                show={showUpload}
                optionalFilePath={optionalFilePath}
                setOptionalFilePath={setOptionalFilePath}
                uploadProgress={uploadProgress}
                totalSize={totalSize()}
            />

            <button type="button" className="btn btn-sm btn-white me-2 px-2" onClick={handleSetShowUpload} ><i className={`fa fa-fw ${!showUpload ? "fa-plus" : "fa-minus"}`}></i> {showUpload ? "Cancel" : "Upload"}</button>
            <button type="button" className="btn btn-sm btn-white me-2 px-2" onClick={goHome} disabled={isRoot} ><i className="fa fa-fw fa-home"></i></button>
            <div className="btn-group me-2">
                <button type="button" className="btn btn-sm btn-white" onClick={moveUp} disabled={isRoot}><i className="fa me-1 fa-arrow-left"></i> Back</button>
            </div>

            {multiSelect && <div className="btn-group me-2">
                <button onClick={selectAll} type="button" className="btn btn-sm btn-white"><i className="fa fa-fw fa-check ms-n1"></i> Select All</button>
                <button onClick={unSelectAll} type="button" className="btn btn-sm btn-white"><i className="far fa-fw fa-square ms-n1"></i> Unselect All</button>
                {arrayAny(itemsSelected) && <button onClick={deleteSelectedItems} type="button" className="btn btn-sm btn-white"><i className="fa fa-fw fa-trash ms-n1"></i> Delete Selected</button>}
            </div>}
            <button disabled={refreshDisabled} onClick={refresh} type="button" className="btn btn-sm btn-white me-2 px-2"><i className={`fa fa-fw fa-arrows-rotate ${refreshDisabled ? "fa-pulse" : ""}`}></i></button>

            <div className="btn-group mt-2">
                <div className="form-check form-switch mb-2 me-3">
                    <input className="form-check-input" type="checkbox" id="showCheckboxes" onChange={handleShowMultiSelectToggle} checked={multiSelect} data-gtm-form-interact-field-id="0" />
                    <label className="form-check-label" htmlFor="showCheckboxes">Check Boxes</label>
                </div>
                <div className="form-check form-switch mb-2">
                    <input className="form-check-input" type="checkbox" id="showDeletedFiles" onChange={handleShowDeletedToggle} checked={showDeleted} data-gtm-form-interact-field-id="0" />
                    <label className="form-check-label" htmlFor="showDeletedFiles">Show Deleted</label>
                </div>
            </div>

        </div>
    );
};